// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Q5RI","productName":"Table_productName__17AjW"};